/**
 * Dependencies
 */
import http from '../../../../services/HttpService'

/**
 * Reset the portfolio context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Get the single portfolio
 *
 * @param  {[type]} options.commit    [description]
 * @param  {[type]} options.rootState [description]
 * @return {[type]}                   [description]
 */
const getPortfolio = ({ commit, rootState }) => {
    commit('SET_PENDING')
    http.get(`portfolios/${rootState.route.params.portfolioId}/`)
        .then(res => commit('SET_PORTFOLIO', res.data))
        .then(res => commit('RESET_PENDING'))
        .catch(err => {
            commit('SET_ERROR', err)
            commit('RESET_PENDING')
        })
}

export default {
    resetState,
    getPortfolio
}



// WEBPACK FOOTER //
// ./src/state/modules/portfolios/single/actions.js